// Only what en-AU says differently; every other string is en-US (mergeLocaleResources).
export const navigation = {
  stack: {
    forgotPassword: "Forgot password",
    setNewPassword: "Set new password",
    newAsset: "New asset",
    addDocument: "Add document",
    renewDocument: "Renew document",
    newChecklist: "New checklist",
    newInspection: "New inspection",
    convertToJobs: "Create jobs",
    inspectionReview: "Inspection review",
    contractorHome: "Contractor home",
    scheduleInspection: "Schedule inspection",
    scheduleDetails: "Schedule details",
    teamManagement: "Team management",
    teamInvitation: "Team invitation",
    workspaceAiAudit: "Workspace AI audit",
  },
  shell: {
    accountNavOrganization: "Organisation",
  },
} as const;
